import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "form-group mb-25" }
const _hoisted_4 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_5 = ["placeholder", "value"]
const _hoisted_6 = { class: "col-xl-4" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("adjustment_page.notes")), 1),
        _createElementVNode("textarea", {
          cols: "30",
          rows: "5",
          placeholder: _ctx.$t('adjustment_page.add_note'),
          class: "d-block w-100 bg-white border-0 rounded-1 resize-none fs-14 text-title p-3",
          value: _ctx.modelValue,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)))
        }, null, 40, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "btn style-one d-inline-block transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 mb-60",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit'))),
        disabled: _ctx.isSubmitting
      }, _toDisplayString(_ctx.isSubmitting ? _ctx.$t("adjustment_page.submitting") : _ctx.$t("adjustment_page.submit_products")), 9, _hoisted_7)
    ])
  ]))
}